<div class="premiumOfferContainer">
    <p class="message">
        <span>{{ "offerBanner.firstLine" | translate }}</span>
    </p>
    <div (click)="goToOffers()" class="goBtn">
        {{ "offerBanner.btn" | translate }}
    </div>
</div>
